import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ScrollMarquee from "@/components/Marquee";
import Trusted from "@/components/Trusted";
import About from "@/components/About";
import Shows from "@/components/Shows";
import Gallery from "@/components/Gallery";
import Music from "@/components/Music";
import InstagramSection from "@/components/Instagram";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => (
  <main data-testid="home-page">
    <Navbar />
    <Hero />
    <Trusted />
    <ScrollMarquee />
    <About />
    <ScrollMarquee dark />
    <Shows />
    <Gallery />
    <Music />
    <InstagramSection />
    <Contact />
    <Footer />
  </main>
);

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#050505",
            border: "1px solid rgba(0,51,153,0.5)",
            color: "#F2F2F2",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
